<template>
    <div
        class="panel"
        :class="{
            'selected': ($parent.lessonId === lesson.id),
        }"
    >
        <strong>
            {{ $filters.striphtml(title) }}
        </strong>

        <div
            v-for="component in components"
            :key="component.id"
        >
            <div
                v-if="(component.translations && component.translations.length)"
                v-html="component.translations[0].content"
            >
            </div>
            <div
                v-else
                v-html="component.content"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SeriesOutlineLesson",

    props: {
        lesson: {
            type: Object,
            required: true,
        },
    },

    computed: {
        titleComponent: function() {
            // get the title component
            return this.lesson.components[0];
        },
        title: function() {
            // get the original OR translated title
            return (this.titleComponent.translations.length ? this.titleComponent.translations[0].content : this.titleComponent.content);
        },
        components: function() {
            // get components, except the first one
            return this.lesson.components.slice(1);
        },
    },
};
</script>

<style lang="scss">
    .panel
    {
        padding: 1em 0.55em;
        border-bottom: 1px solid #ddd;

        &.selected
        {
            background-color: rgba(255, 255, 0, 0.14);
            border-bottom: 1px solid #ddd !important;
        }

        &:last-child
        {
            border-bottom: none;
        }
    }
</style>
